
const av = Autodesk.Viewing;

const namespace = AutodeskNamespace('Autodesk.AEC');
const myExtensionName = 'Autodesk.AEC.DisciplinesExtension';
/* resources */
import disciplines_lang_cs from '../../../res/locales/cs/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_de from '../../../res/locales/de/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_en from '../../../res/locales/en/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_es from '../../../res/locales/es/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_fr from '../../../res/locales/fr/viewer-aec-disciplines.loc-generated.json';
//import disciplines_lang_fr_CA from '../../../../res/locales/fr-CA/viewer-aec-disciplines.loc-generated.json';
//import disciplines_lang_hu from '../../../res/locales/hu/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_it from '../../../res/locales/it/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_ja from '../../../res/locales/ja/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_ko from '../../../res/locales/ko/viewer-aec-disciplines.loc-generated.json';
//import disciplines_lang_nl from '../../../res/locales/nl/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_pl from '../../../res/locales/pl/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_pt_BR from '../../../res/locales/pt-BR/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_ru from '../../../res/locales/ru/viewer-aec-disciplines.loc-generated.json';
//import disciplines_lang_sv from '../../../res/locales/sv/viewer-aec-disciplines.loc-generated.json';
//import disciplines_lang_tr from '../../../res/locales/tr/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_zh_Hans from '../../../res/locales/zh-Hans/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_zh_Hant from '../../../res/locales/zh-Hant/viewer-aec-disciplines.loc-generated.json';
import disciplines_lang_zh_HK from '../../../res/locales/zh-HK/viewer-aec-disciplines.loc-generated.json';

/**
 * @param {Record<locale, {key: string, name: string}>} disciplinesMap:
 */
function translateDisciplines(disciplinesMap) {
    // TODO: still needed?
    // Translate default disciplines (from disciplines.json) to the void and then write translation to the Caption
    // value in the loop below.
    av.i18n.t('Architecture');
    av.i18n.t('Structure');
    av.i18n.t('Mechanical');
    av.i18n.t('Electrical');
    av.i18n.t('Piping');

    for (const disciplines of Object.values(disciplinesMap)) {
        disciplines.forEach((discipline) => {
            if (av.i18n.exists(discipline.Key)) {
                discipline.Name = av.i18n.t(discipline.Key);
            }
        });
    }
}

/**
 * @returns {Record<locale, {key: string, name: string}>}
 */
function initDisciplines() {

    const disciplinesMap = {
        'cs': disciplines_lang_cs.slice(0),
        'de': disciplines_lang_de.slice(0),
        'en': disciplines_lang_en.slice(0),
        'es': disciplines_lang_es.slice(0),
        'fr': disciplines_lang_fr.slice(0),
        //'fr-CA': disciplines_lang_fr_CA.slice(0),
        //'hu': disciplines_lang_hu.slice(0),
        'it': disciplines_lang_it.slice(0),
        'ja': disciplines_lang_ja.slice(0),
        'ko': disciplines_lang_ko.slice(0),
        //'nl': disciplines_lang_nl.slice(0),
        'pl': disciplines_lang_pl.slice(0),
        'pt-BR': disciplines_lang_pt_BR.slice(0),
        'ru': disciplines_lang_ru.slice(0),
        //'sv': disciplines_lang_sv.slice(0),
        //'tr': disciplines_lang_tr.slice(0),
        'zh-Hans': disciplines_lang_zh_Hans.slice(0),
        'zh-Hant': disciplines_lang_zh_Hant.slice(0),
        'zh-HK': disciplines_lang_zh_HK.slice(0),
    };
    translateDisciplines(disciplinesMap); // Translate before we allow 3rd-parties to modify the list
    return disciplinesMap;
}

// TODO: improve this logic, use cb to iterate dbId's
function enumDbIds(model, cb) {
    const frags = model.getData().fragments;
    const fragList = model.getFragmentList();

    // Note that multiple dbIds per fragment do only happen for F2D models
    // => We can safely assume that all elements are numbers.
    for (const fragId of frags.fragId2dbId) {
        if (!fragList.isNotLoaded(fragId)) {
            const result = cb(fragId);
            if (result) {
                return result;
            }
        }
    }
}

function getCategory(tree, id, options) {
    if (options?.getCategory) {
        let category = options.getCategory(tree, id);
        if (category !== undefined) {
            return category;
        }
    }

    switch (options?.mimeType) {
        case 'application/vnd.autodesk.f3d':
        case 'application/vnd.autodesk.fusion360':
            // the real fusion object (Fan 60x60.f3d v1:1)
            id = tree.getNodeParentId(id) || id;
            // the container (Base Assembly.f3d v1:1)
            id = tree.getNodeParentId(id) || id;
            break;
        default:
            // the node right under the root
            while (tree.getNodeParentId(id) != tree.getRootId()) {
                id = tree.getNodeParentId(id);
                if (!id) {
                    break;
                }
            }
    }

    return id ? tree.getNodeName(id) : 'Unknown';
}

function enumCategories(model, cb, options) {
    const tree = model.getObjectTree();
    return tree && enumDbIds(model, (id) => {
        const category = getCategory(tree, id, options);
        return cb(category);
    });
}

/**
// DisciplinesExtension - A viewer extension providing localized disciplines for different languages.
//
// @param {Viewer3D}         [viewer]  - viewer instance
// @param {{getDisciplines}} [options] - Configuration options for disciplines. getDisciplines receives a map Record<loc, disciplines> and returns also a map of Record<loc, disciplines>
*/
export default class DisciplinesExtension extends Autodesk.Viewing.Extension {
    constructor(viewer, options) {
        super(viewer, options?.Disciplines ?? options);
        this.baseDisciplines = initDisciplines();
    }

    async load() {
        return true;
    }

    unload() {
        return true;
    }

    getDisciplines(getDisciplineCB, addMiscellaneous = true) {

        // clone
        const disciplinesMap = structuredClone(this.baseDisciplines);

        if (addMiscellaneous) {
            for (const [lng, disciplines] of Object.entries(disciplinesMap)) {
                const miscDiscipline = {
                    Key: 'Miscellaneous',
                    Name: av.i18n.t('Miscellaneous', { lng }),
                    Categories: [],
                    DisplayOrder: 999,
                    _MiscDiscipline: true,
                };

                disciplines.push(miscDiscipline);
            }
        }

        // sort
        for (const disciplines of Object.values(disciplinesMap)) {
            disciplines.sort((a, b) => { return a.DisplayOrder - b.DisplayOrder; });
        }

        if (getDisciplineCB) {
            return getDisciplineCB(disciplinesMap);
        }
        return disciplinesMap;
    }

    getModelLanguage(model) {
        const allDisciplines = this.baseDisciplines;
        const getLng = (category) => {
            for (const [lng, disciplines] of Object.entries(allDisciplines)) {
                for (const prospectDisciplines of Object.values(disciplines)) {
                    for (const prospectCategory of prospectDisciplines.Categories) {
                        if (category == prospectCategory) {
                            console.info(`Discipline language '${lng}' detected ` +
                                `(for category '${prospectCategory}')`);
                            return lng;
                        }
                    }
                }
            }
        };
        console.time('Discipline language check');
        const language = enumCategories(model, getLng);
        console.timeEnd('Discipline language check');
        return language ?? 'en';
    }

}

Object.assign(namespace, { DisciplinesExtension });
namespace.DisciplinesExtension = DisciplinesExtension;
av.theExtensionManager.registerExtension(myExtensionName, DisciplinesExtension);
